import * as AppActions from './app.actions';

export const APP_STATE_NAME = 'app';

const INITIAL_STATE = {
  initialized: false,
  logoUrl: '',
  cornerIcon: ''
};

export default (state = INITIAL_STATE, {type, payload}) => {
  switch (type) {
    case AppActions.APP_INITIALIZED:
      return {...state, initialized: true};
    case AppActions.SET_APP_BRANDING:
      return {...state, logoUrl: payload.logoUrl, cornerIcon: payload.cornerIcon};
    case AppActions.REDIRECT_USER:
      return {...state, redirectToState: payload.state};
    default:
      return state;
  }
};
